const yaEventsMap = {
  /* Действия в разделе "Регистрация в приложении Nedvex" */
  Web_User_Registration: 'отправить',
  Web_Phone_Number_Entered: 'подтвердить',

  /* Подписка */
  SUBSCRIPTION: 'подписка',

  /* Действия в разделах "Новостройки" или "КП и ТХ" */
  Web_KP: 'вкладка_кптх',
  Web_ZHK: 'вкладка_новостройки',
  Web_ZHK_Nedvex: 'жк_nedvex',
  Web_New: 'новинки',
  Web_Stock: 'акции',
  Web_Popular: 'популярное',
  Web_Search: 'поиск_на_списке',
  Web_Sort_Date: 'сортировка_по_дате',
  Web_Sort_Price_Cheaper: 'сортировка_по_увеличение_цены',
  Web_Sort_Price_Expensive: 'сортировка_по_уменьшению_цены',
  Web_Sort_Title: 'сортировка_по_названию',
  Web_Filters_District: 'район',
  Web_Filters_Price: 'цена',
  Web_Filters_Price_General: 'общая_цена',
  Web_Filters_Price_Kv: 'цена_за_метр',
  Web_Filters_Square: 'площадь',
  Web_Filters_Decoration: 'оформление',
  'Web_Filters_FZ-214': 'фз214',
  'Web_Filters_FZ-215': 'фз215',
  Web_Filters_Justice: 'юстиция',
  Web_Filters_Delivery_Deadline: 'срок_сдачи',
  Web_Filters_Passed: 'дом_сдан',
  Web_Filters_2022: '2022',
  Web_Filters_2023: '2023',
  Web_Filters_2024: '2024',
  Web_Filters_2025: '2025',
  Web_Filters_2026: '2026',
  Web_Filters_2027: '2027',
  Web_Filters_Payment_Options: 'варианты_оплаты',
  Web_Filters_Mortgage: 'ипотека',
  Web_Filters_Installment: 'рассрочка',
  Web_Filters_Military_Mortgage: 'военная_ипотека',
  Web_Filters_Maternity_Capital: 'материнский_капитал',
  Web_Filters_Finishing: 'чистовая',
  Web_Filters_Repair: 'ремонт',
  Web_Filters_Flat: 'квартира',
  Web_Filters_Apartments: 'апартаменты',
  Web_Filters_Up_To_500: 'до_500',
  Web_Filters_Up_To_1500: 'до_1500',
  Web_Filters_Up_To_3000: 'до_3000',
  Web_Filters_Economy: 'эконом',
  Web_Filters_Comfort: 'комфорт',
  Web_Filters_Business: 'бизнес',
  Web_Filters_Elite: 'элит',
  Web_Filters_Parking: 'паркинг',
  Web_Filters_Concierge: 'консьерж',
  Web_Filters_Recreation_Area: 'зона_отдыха',
  Web_Filters_Recreation_Elevator: 'лифт',
  Web_Filters_Children_Playground: 'детская_площадка',
  Web_Filters_Swimming_Pool: 'бассейн',
  Web_Filters_House_Territory: 'закрытая_территория',
  Web_Map: 'искать_на_карте',
  Web_Map_Object_List: 'искать_на_списке',
  Web_Click: 'объект',
  Web_Add_To_Collection: 'в_подборку',
  Web_Add_To_Favorites: 'добавить_в_избранное',
  Web_Remove_From_Favorites: 'удалить_из_избранного',

  /* Действия в "Карточке объекта" */
  Web_Card_Add_Selection: 'добавить_жк_в_подборку',
  Web_Card_Add_Favorites: 'добавить_жк_в_избранное',
  Web_Card_Remove_Favorites: 'удалить_жк_из_избранного',
  Web_Card_Share: 'поделиться_ссылкой',
  Web_Card_Print: 'печать_информации',
  Web_Card_Checkerboard: 'посмотреть_шахматку',

  /* Действия в "Шахматке объекта" */
  Web_List_Checkerboard: 'шахматка',
  Web_List_Premises: 'список_лотов',
  Web_List_Filters_Price: 'фильтр_цена_в_шахматке',
  Web_List_Filters_Price_General: 'фильтр_общая_цена_в_шахматке',
  Web_List_Filters_Price_Kv: 'фильтр_цена_за_метр_в_шахматке',
  Web_List_Filters_Square: 'фильтр_площадь_в_шахматке',
  Web_List_Filters_Finishing: 'фильтр_чистовая_в_объекте',
  Web_List_Filters_Repair: 'фильтр_ремонт_в_объекте',
  Web_List_Filters_Rough: 'фильтр_черновая_в_объекте',
  Web_List_Filters_Partial_Repair: 'фильтр_частичный_ремонт_в_объекте',
  Web_List_Filters_Pre_Finishing: 'фильтр_пред_чистовая_в_объекте',
  Web_List_Filters_Extended_Activation: 'фильтр_расширенная_шахматка',
  /* Действия в разделе "Подборки" */
  Web_Selections: 'подборки',
  Web_Current_Add_To_Collection: 'создать_подборку',
  Web_Selections_Duplicate: 'дублировать_в_подборке',
  Web_Selections_Delete: 'удалить_в_подборке',
  Web_Selections_Edit: 'переименовать_в_подборке',
  Web_Selections_Share: 'отправить_подборку_в_подборке',
  Web_Selections_Add_Comment: 'оставить_комеентарий_в_подборке',
  Web_Selections_Edit_Comment: 'редактировать_комментарий_в_подборке',
  Web_Selections_Delete_Comment: 'удалить_в_подборке',

  /* Действия в разделе "Избранное" */
  Web_Favorites_Delete: 'убрать_из_избранного',
  Web_Favorites_Go_Object: 'перейти_в_жк',

  /* Действия в разделе "Профиль" */
  Web_Profile: 'профиль',
  Web_My_Profile: 'мой_профиль',
  Web_Profile_Company: 'профиль_компании',
  Web_Profile_With_Client: 'я_с_клиентом',
  Web_Profile_Renew_Subscription: 'оплатить',

  /* Попап шаринга объекта */
  Web_ShareDialog_NameAddress: 'название и адрес',
  Web_ShareDialog_Description: 'описание и преимущества',
  Web_ShareDialog_Characteristics: 'характеристики',
  Web_ShareDialog_Communications: 'коммуникации',
  Web_ShareDialog_Checkout: 'оформление',
  Web_ShareDialog_Payment: 'оплата',
  Web_ShareDialog_Lots: 'лоты',
  Web_ShareDialog_Link: 'ссылка',
  Web_ShareDialog_CopyButton: 'скопировать',
  Web_ShareDialog_SavePdf: 'сохранить pdf-файл',

  /* Попап шаринга подборки */

  Web_ShareCollectionDialog_NameAddress: 'название и адрес в подборке',
  Web_ShareCollectionDialog_Description: 'описание и преимущества в подборке',
  Web_ShareCollectionDialog_Characteristics: 'характеристики в подборке',
  Web_ShareCollectionDialog_Communications: 'коммуникации в подборке',
  Web_ShareCollectionDialog_Checkout: 'оформление в подборке',
  Web_ShareCollectionDialog_Payment: 'оплата в подборке',
  Web_ShareCollectionDialog_Map: 'карта в подборке',
  Web_ShareCollectionDialog_Lots_0: 'показывать все лоты',
  Web_ShareCollectionDialog_Lots_1: 'только отобраннные лоты',
  Web_ShareCollectionDialog_Lots_2: 'не отображать лоты',
  Web_ShareCollectionDialog_Link: 'ссылка в подборке',
  Web_ShareCollectionDialog_CopyButton: 'скопировать в подборке',
  Web_Lots_AddToCollection: 'добавить_в_подборку',
  Web_Lots_AddToNewCollection: 'создание_подборки_при_добавлении_лота'
};

const keysMap = {
  mode: {
    title: 'вид',
    values: {
      map: 'карта',
      list: 'список'
    }
  },
  selected: {
    title: 'режим',
    values: {
      true: 'установка',
      false: 'снятие'
    }
  },
  name: 'название'
};

class ymService {
  sendEvent(eventName, params = {}) {
    const paramsKeys = Object.keys(params);
    const newParams = paramsKeys.length ? paramsKeys.reduce((acc, paramName) => {
      const value = params[paramName];

      if (!keysMap[paramName]) {
        acc[paramName] = value;
        return acc;
      }

      if (typeof keysMap[paramName] === 'string') {
        const name = keysMap[paramName];
        acc[name] = value;
        return acc;
      }

      const name = keysMap[paramName].title;
      acc[name] = keysMap[paramName].values[value];

      return acc;
    }, {}) : undefined;

    const name = yaEventsMap[eventName];

    ym(92364884, 'reachGoal', name, newParams ? {
      [name]: newParams
    } : undefined);

    console.log('tracker: ymService', 'reachGoal', name, newParams ? {
      [name]: newParams
    } : undefined);
  }
}

export default new ymService();



// WEBPACK FOOTER //
// ./src/services/ym.js